import {useContext, useState, useEffect} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import MoneyInterface from "../../interfaces/core/MoneyInterface";
import {getSuffixByCount} from "../../utils/Utils";
import Money from "../core/Money";
import {CustomerInterface} from "../../interfaces/customer/CustomerInterface";
import {CustomerAccountInterface} from "../../interfaces/customer/CustomerAccountInterface";
import {CustomerConsigneeInterface} from "../../interfaces/customer/CustomerConsigneeInterface";

export default function TotalBlock({
                                         selectedAccount,
                                         selectedConsignee,
                                         setSelectedAccount,
                                         setSelectedConsignee,
                                         createOrder
                                     }: {
    selectedAccount: CustomerAccountInterface | null,
    selectedConsignee: CustomerConsigneeInterface | null,
    setSelectedAccount: (selectedAccount: CustomerAccountInterface | null) => void,
    setSelectedConsignee: (selectedConsignee: CustomerConsigneeInterface | null) => void,
    createOrder: () => void
}) {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const customer = state.customer as CustomerInterface;
    const accounts = customer?.accounts || [];
    const consignees = customer?.consignees || [];

    useEffect(() => {
        if (accounts.length > 0 && !selectedAccount) {
            setSelectedAccount(accounts[0]);
        }
    }, [accounts, selectedAccount]);

    useEffect(() => {
        if (consignees.length > 0 && !selectedConsignee) {
            setSelectedConsignee(consignees[0]);
        }
    }, [consignees, selectedConsignee]);

    const getBasketItemsWithStock = () => {
        return state.basket.filter(item => item.product.has_client_stock);
    }

    const getCurrentTotal = (): MoneyInterface => {
        const currency = state.basket.length ? (state.basket[0].product.client_price || state.basket[0].product.current_price).currency : {name: 'RUB'};
        return {
            amount: getBasketItemsWithStock().reduce((total, item) => total + (item.product.client_price || item.product.current_price).amount * item.quantity, 0),
            currency: currency
        };
    }

    const getBaseTotal = (): MoneyInterface => {
        const currency = state.basket.length ? (state.basket[0].product.client_base_price || state.basket[0].product.base_price).currency : {name: 'RUB'};
        return {
            amount: getBasketItemsWithStock().reduce((total, item) => total + (item.product.client_base_price || item.product.base_price).amount * item.quantity, 0),
            currency: currency
        };
    }

    const getDiscountTotal = (): MoneyInterface => {
        const currentTotal = getCurrentTotal();
        const baseTotal = getBaseTotal();
        return {amount: baseTotal.amount - currentTotal.amount, currency: currentTotal.currency};
    }

    const getTotalWeight = (): number => {
        return Math.round(getBasketItemsWithStock().reduce((total, item) => total + (item.product.weight ? item.product.weight * item.quantity : 0), 0) * 100) / 100;
    }

    const getTotalQuantity = (): number => {
        return getBasketItemsWithStock().reduce((total, item) => total + item.quantity, 0);
    }

    return (<div className="d-flex flex-column basket__info if-basket">
        {/*<div className="d-flex justify-content-between align-items-end if-basket__head">*/}
        {/*    <span>Баланс</span>*/}
        {/*    <span className="price fw-medium">2 360 ₽</span>*/}
        {/*</div>*/}
        <div className="d-flex flex-column if-basket__body">
            {state.customer && <div className="d-flex flex-column if-basket__item">
                <div className="d-flex align-items-center if-basket__l-row">
                    <p className="t-gray">Покупатель</p>
                    {/*<a href="#" className="bs-link min-13">изменить</a>*/}
                </div>
                <p className="text-uppercase fw-medium">{state.customer?.name}</p>
            </div>}

            {state.customer && accounts.length > 0 && <div className="d-flex flex-column if-basket__item">
                <div className="d-flex align-items-center if-basket__l-row">
                    <p className="t-gray">Лицевой счет</p>
                </div>
                <select
                    className="form-select fw-medium"
                    value={selectedAccount?.id || ''}
                    disabled={accounts.length === 1}
                    onChange={(e) => {
                        const accountId = parseInt(e.target.value);
                        const account = accounts.find(acc => acc.id === accountId);
                        setSelectedAccount(account || null);
                    }}
                >
                    {accounts.map(account => (
                        <option key={account.id} value={account.id}>
                            {account.name}
                        </option>
                    ))}
                </select>
            </div>}

            {state.customer && consignees.length > 0 && <div className="d-flex flex-column if-basket__item">
                <div className="d-flex align-items-center if-basket__l-row">
                    <p className="t-gray">Грузополучатель</p>
                </div>
                <select
                    className="form-select fw-medium"
                    value={selectedConsignee?.id || ''}
                    disabled={consignees.length === 1}
                    onChange={(e) => {
                        const consigneeId = parseInt(e.target.value);
                        const consignee = consignees.find(cons => cons.id === consigneeId);
                        setSelectedConsignee(consignee || null);
                    }}
                >
                    {consignees.map(consignee => (
                        <option key={consignee.id} value={consignee.id}>
                            {consignee.name}
                        </option>
                    ))}
                </select>
            </div>}

            {/*<div className="d-flex flex-column if-basket__item">*/}
            {/*    <div className="d-flex align-items-center if-basket__l-row">*/}
            {/*        <p className="t-gray">Адрес доставки</p>*/}
            {/*        <a href="#" className="bs-link min-13">изменить</a>*/}
            {/*    </div>*/}
            {/*    <p className="text-uppercase fw-medium">Москва, ул. боровая, 8</p>*/}
            {/*</div>*/}
            <div className="d-flex flex-column if-basket__item">
                <div className="d-flex align-items-center justify-content-between if-basket__i-box">
                    <div className="d-flex align-items-center if-basket__l-row">
                        <p className="t-gray">{getTotalQuantity()} товар{getSuffixByCount(getTotalQuantity())}</p>
                        <p className="t-gray min-12">{getTotalWeight()} кг</p>
                    </div>
                    <p className="fw-bold big"><Money value={getBaseTotal()}/></p>
                </div>
                {getDiscountTotal().amount > 0 &&
                    <div className="d-flex align-items-center justify-content-between if-basket__i-box">
                        <p className="min-14">Скидка</p>
                        <p className="min-14">-<Money value={getDiscountTotal()}/></p>
                    </div>}
            </div>
        </div>
        <div className="d-flex align-items-center justify-content-between if-basket__i-box if-basket__bot">
            <p className="fw-medium t-orange">итого</p>
            <p className="price fw-medium t-orange"><Money value={getCurrentTotal()}/></p>
        </div>

        {state.customer &&
            <button className="d-flex align-items-center justify-content-center big btn btn-primary if-basket__btn"
                    onClick={() => createOrder()}>
                <span>Оформить заказ</span>
            </button>}
        {!state.customer &&
            <h5 className={'text-center text-danger'}>Для оформления заказа необходимо авторизоваться</h5>}
    </div>)
}